import { useState } from "react";
import { toast } from "sonner";
import { LocateFixed } from "lucide-react";
import { LOCATIONS, distanceMiles } from "@/content/locations";
import { LocationMap } from "@/components/site/LocationMap";
import { LocationCard } from "@/components/site/LocationCard";

export const LocationsExplorer = () => {
  const [active, setActive] = useState(null);
  const [nearest, setNearest] = useState(null);

  const findNearest = () => {
    if (!navigator.geolocation) {
      toast.error("Location isn't available in this browser.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const here = [coords.latitude, coords.longitude];
        const best = LOCATIONS
          .map((l) => ({ l, d: distanceMiles(here, l.coords) }))
          .sort((a, b) => a.d - b.d)[0];
        setActive(best.l.slug);
        setNearest(`${best.l.name} is your closest TeaDM — about ${best.d.toFixed(1)} miles away.`);
        document.getElementById(`loc-${best.l.slug}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
      },
      () => toast.error("We couldn't get your location. Pick a store from the list instead."),
      { timeout: 8000 },
    );
  };

  return (
    <div className="grid gap-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <LocationMap active={active} onSelect={setActive} className="h-[380px] sm:h-[460px] lg:h-[calc(100svh-9rem)]" />
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <button type="button" onClick={findNearest} data-testid="find-nearest-btn" className="btn btn-ink"><LocateFixed className="h-4 w-4" />Find my nearest</button>
          </div>
          {nearest && <p data-testid="nearest-result" className="mt-3 font-semibold">{nearest}</p>}
        </div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:col-span-7">
        {LOCATIONS.map((l, i) => (
          <div key={l.slug} id={`loc-${l.slug}`}>
            <LocationCard loc={l} index={i} active={active === l.slug} onFocus={() => setActive(l.slug)} />
          </div>
        ))}
      </div>
    </div>
  );
};
